// extracted by mini-css-extract-plugin
export default {"shopHeader":"shopHeaderNew_shopHeader__I7hH7","header":"shopHeaderNew_header__EoxbP"};